<div class="wrapper wrapper-content animated fadeInRight">
  
  <!-- Top Bar Actions -->
  <div class="row">
    <div class="col-lg-12">
      <div class="top-bar-actions">
        <div class="action-group">
          <label style="margin: 0 10px 0 0;">Course:</label>
          <select id="courseSelector" class="form-control form-control-inline" style="width: 250px;">
            <option value="101" data-course-name="Black Desert Resort">Black Desert Resort</option>
            <option value="102" data-course-name="North Course">North Course</option>
          </select>
          <span class="text-muted" style="font-size: 11px; margin-left: 5px;">
            (RTC ID: <span id="rtcId">101</span>)
          </span>
          <button class="btn btn-info btn-sm">
            <i class="fa fa-copy"></i> Copy Pairings from Previous Round
          </button>
        </div>
        <div class="action-group">
          <label style="margin: 0 10px 0 0;">Reports:</label>
          <select class="form-control form-control-inline" style="width: 200px;">
            <option>Alpha Pairings Sheet</option>
            <option>Pairings by Group</option>
            <option>Starting Times</option>
          </select>
          <button class="btn btn-white btn-sm">
            <i class="fa fa-print"></i> Print
          </button>
        </div>
        <div class="action-group">
          <button class="btn btn-primary btn-sm" disabled>
            <i class="fa fa-upload"></i> Publish
          </button>
          <span class="publish-status">
            <i class="fa fa-clock-o"></i> Published At: 5/4/2025 1:08 AM
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Settings Panel -->
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox collapsed">
        <div class="ibox-title">
          <h5><i class="fa fa-cog"></i> Group Creation and Pairings Tools</h5>
          <div class="ibox-tools">
            <a class="collapse-link">
              <i class="fa fa-chevron-down"></i>
            </a>
          </div>
        </div>
        <div class="ibox-content" style="display: none;">
          <div class="pairing-settings-panel">
            <h4 class="m-b-md">Automatic Settings</h4>
            <div class="settings-grid">
              <!-- Column 1: Players & Groups -->
              <div>
                <div class="form-group">
                  <label>Players in Field:</label>
                  <input type="number" class="form-control" value="68" />
                </div>
                <div class="form-group">
                  <label>'A' Players:</label>
                  <input type="number" class="form-control" value="60" />
                </div>
                <div class="form-group">
                  <label>Players per Group:</label>
                  <select class="form-control">
                    <option>2</option>
                    <option selected>3</option>
                    <option>4</option>
                  </select>
                </div>
                <div class="form-group">
                  <label># of Groups:</label>
                  <input type="text" class="form-control" value="23" readonly />
                </div>
              </div>

              <!-- Column 2: Tees & Waves -->
              <div>
                <div class="form-group">
                  <label>Number of Tees:</label>
                  <select class="form-control">
                    <option>1</option>
                    <option selected>2</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Number of Waves:</label>
                  <select class="form-control">
                    <option selected>1</option>
                    <option>2</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Number of Blocks:</label>
                  <input type="text" class="form-control" value="2" readonly />
                </div>
              </div>

              <!-- Column 3: Times -->
              <div>
                <div class="form-group">
                  <label>1st Wave Start Time:</label>
                  <input type="text" class="form-control" value="7:00 AM" />
                </div>
                <div class="form-group">
                  <label>Interval (Minutes):</label>
                  <input type="number" class="form-control" value="11" />
                </div>
                <div class="form-group">
                  <label># Sequence:</label>
                  <select class="form-control">
                    <option>Odd/Even</option>
                    <option selected>Sequential</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Round 2+ Options -->
            <div class="alert alert-info">
              <h4><i class="fa fa-info-circle"></i> Round 2+ Settings</h4>
              <div class="row">
                <div class="col-md-3">
                  <div class="checkbox checkbox-primary">
                    <input type="checkbox" id="flipFlop" checked>
                    <label for="flipFlop">Flip Flop</label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="checkbox checkbox-primary">
                    <input type="checkbox" id="repairByScore" checked>
                    <label for="repairByScore">Repair by Score</label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="row">
              <div class="col-lg-12 text-right">
                <button class="btn btn-white">
                  <i class="fa fa-trash"></i> Clear Groups
                </button>
                <button class="btn btn-success">
                  <i class="fa fa-plus"></i> Create Groups
                </button>
                <button class="btn btn-white">
                  <i class="fa fa-eraser"></i> Clear Pairings
                </button>
                <button class="btn btn-primary">
                  <i class="fa fa-magic"></i> Create Pairings
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content: Groups List & Sidebar -->
  <div class="row">
    <div class="col-lg-12">
      <div class="content-split">
        <!-- Groups List (70%) -->
        <div class="groups-section">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Groups/Pairings (72 Groups)</h5>
              <div class="ibox-tools">
                <span class="label label-primary">All Players Assigned</span>
              </div>
            </div>
            <div class="ibox-content">
              <div class="table-responsive" style="max-height: 600px; overflow-y: auto;">
                <table class="table table-striped table-bordered groups-table">
                  <thead>
                    <tr>
                      <th>Grp</th>
                      <th>Tee</th>
                      <th>Tee Time</th>
                      <th>W</th>
                      <th>B</th>
                      <th style="width: 25%;">Player 1</th>
                      <th style="width: 25%;">Player 2</th>
                      <th style="width: 25%;">Player 3</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Block 1: 1st Tee Morning -->
                    <tr class="block-header">
                      <td colspan="9">Block 1: 1st Tee Morning</td>
                    </tr>
                    <tr class="block-1">
                      <td>1</td>
                      <td>1</td>
                      <td>7:00 AM</td>
                      <td>1</td>
                      <td>1</td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>O'Toole, Ryann</option>
                          <option>Duncan, Lindy</option>
                        </select>
                      </td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Duncan, Lindy</option>
                          <option>O'Toole, Ryann</option>
                        </select>
                      </td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Dryburgh, Gemma</option>
                        </select>
                      </td>
                      <td>
                        <button class="btn btn-xs btn-white" title="Edit Group">
                          <i class="fa fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                    <tr class="block-1 group-a">
                      <td>5</td>
                      <td>1</td>
                      <td>7:22 AM</td>
                      <td>1</td>
                      <td>1</td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Nordqvist, Anna</option>
                        </select>
                      </td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Kupcho, Jennifer</option>
                        </select>
                      </td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Kim, Grace</option>
                        </select>
                      </td>
                      <td>
                        <button class="btn btn-xs btn-white">
                          <i class="fa fa-edit"></i>
                        </button>
                      </td>
                    </tr>

                    <!-- Block 2: 10th Tee Morning -->
                    <tr class="block-header">
                      <td colspan="9">Block 2: 10th Tee Morning</td>
                    </tr>
                    <tr class="block-2">
                      <td>2</td>
                      <td>10</td>
                      <td>7:00 AM</td>
                      <td>1</td>
                      <td>2</td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Gillman, Kristen</option>
                        </select>
                      </td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Yin, Ruoning</option>
                        </select>
                      </td>
                      <td>
                        <select class="form-control input-sm">
                          <option selected>Katsu, Minami</option>
                        </select>
                      </td>
                      <td>
                        <button class="btn btn-xs btn-white">
                          <i class="fa fa-edit"></i>
                        </button>
                      </td>
                    </tr>

                    <!-- More rows would continue... -->
                    <tr class="block-2">
                      <td colspan="9" class="text-center text-muted">
                        <em>... 67 more groups ...</em>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Sidebar Tabs (30%) -->
        <div class="sidebar-section">
          <div class="ibox">
            <div class="ibox-content">
              <div class="tabs-container">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a data-toggle="tab" href="#tab-available">Available Players <span class="label label-warning">0</span></a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#tab-alpha">Pairings by Alpha</a>
                  </li>
                  <li>
                    <a data-toggle="tab" href="#tab-swap">Swap</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <!-- Available Players Tab -->
                  <div id="tab-available" class="tab-pane active">
                    <div class="panel-body">
                      <div class="form-group">
                        <input type="text" class="form-control" placeholder="Search players...">
                      </div>
                      <div class="alpha-list">
                        <div class="alert alert-success text-center">
                          <i class="fa fa-check-circle fa-2x"></i>
                          <p class="m-t-sm"><strong>All players assigned!</strong></p>
                          <p class="text-muted">0 players remaining</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Pairings by Alpha Tab -->
                  <div id="tab-alpha" class="tab-pane">
                    <div class="panel-body">
                      <div class="form-group">
                        <input type="text" class="form-control" placeholder="Search by name...">
                      </div>
                      <div class="alpha-list">
                        <table class="table table-condensed table-hover">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>A/B/C</th>
                              <th>R1 Wave</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <strong>An, Narin</strong><br>
                                <small class="text-muted">Grp 13 | Tee 1 | 8:06 AM</small>
                              </td>
                              <td><span class="label label-warning">A</span></td>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Ashok, Aditi</strong><br>
                                <small class="text-muted">Grp 9 | Tee 1 | 7:44 AM</small>
                              </td>
                              <td><span class="label label-info">B</span></td>
                              <td>1</td>
                            </tr>
                            <tr>
                              <td colspan="3" class="text-center text-muted">
                                <em>... 66 more players ...</em>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Swap Tab -->
                  <div id="tab-swap" class="tab-pane">
                    <div class="panel-body">
                      <h4>Swap Players</h4>
                      <div class="form-group">
                        <label>Player 1:</label>
                        <select class="form-control">
                          <option>-- Select Player --</option>
                          <option>O'Toole, Ryann (Grp 1, Tee 1)</option>
                          <option>Duncan, Lindy (Grp 1, Tee 1)</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Player 2:</label>
                        <select class="form-control">
                          <option>-- Select Player --</option>
                          <option>Gillman, Kristen (Grp 2, Tee 10)</option>
                          <option>Yin, Ruoning (Grp 2, Tee 10)</option>
                        </select>
                      </div>
                      <button class="btn btn-primary btn-block">
                        <i class="fa fa-exchange"></i> Swap Players
                      </button>

                      <hr>

                      <h4>Swap Groups</h4>
                      <div class="form-group">
                        <label>Group 1:</label>
                        <select class="form-control">
                          <option>-- Select Group --</option>
                          <option>Group 1 (Tee 1, 7:00 AM)</option>
                          <option>Group 5 (Tee 1, 7:22 AM)</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Group 2:</label>
                        <select class="form-control">
                          <option>-- Select Group --</option>
                          <option>Group 2 (Tee 10, 7:00 AM)</option>
                        </select>
                      </div>
                      <button class="btn btn-info btn-block">
                        <i class="fa fa-exchange"></i> Swap Groups
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Placeholder Note -->
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox">
        <div class="ibox-title">
          <h5><i class="fa fa-info-circle"></i> Mockup Preview</h5>
        </div>
        <div class="ibox-content">
          <div class="text-center" style="padding: 20px;">
            <p class="text-muted">This is a preview of the Pairings Generation UI mockup.</p>
            <p class="text-muted">Full functionality will be implemented in future iterations.</p>
            <div style="margin-top: 20px;">
              <button class="btn btn-white btn-lg" (click)="goToCourseAssignment()">
                <i class="fa fa-arrow-left"></i> Back to Course Assignment
              </button>
              <button class="btn btn-white btn-lg" (click)="goBack()" style="margin-left: 10px;">
                <i class="fa fa-list"></i> Back to Rounds
              </button>
            </div>
          </div>
          <p><strong>Mockup File:</strong> <code>docs/designs/pairings-generation-mockup.html</code></p>
          <p><strong>Design Spec:</strong> <code>docs/designs/spec-design-pairings-generation-v1.1.md</code></p>
        </div>
      </div>
    </div>
  </div>
</div>
